'use strict';
var parent = require('../../stable/url-search-params');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/url-search-params/index.js
// module id = 555
// module chunks = 13